var _path, _path2, _path3, _path4, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRoadmapToolsIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 57,
    viewBox: "0 0 42 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.6906 29.1794H0.857451V23.6794H2.69076C2.92909 23.684 3.15826 23.5878 3.32324 23.4136C3.50199 23.244 3.60511 23.008 3.60741 22.7628C3.60741 22.5198 3.51116 22.2861 3.33929 22.1142C3.16741 21.9423 2.93366 21.8461 2.69073 21.8461H0.857422V7.17958C0.857422 3.63668 3.73112 0.762695 7.27431 0.762695C10.8175 0.762695 13.6912 3.63639 13.6912 7.17958V21.8461H11.8579C11.6196 21.8415 11.3904 21.9378 11.2254 22.1119C11.0398 22.2769 10.9367 22.5152 10.9412 22.7628C10.9412 23.0057 11.0375 23.2394 11.2094 23.4113C11.3812 23.5832 11.615 23.6794 11.8579 23.6794H13.6912L13.6906 29.1794ZM2.69076 27.3461H11.8573V25.5127C10.338 25.5127 9.10736 24.2821 9.10736 22.7628C9.10736 21.2434 10.338 20.0128 11.8573 20.0128V7.17961C11.8573 4.64735 9.8063 2.59633 7.27404 2.59633C4.74179 2.59633 2.69076 4.64735 2.69076 7.17961V20.0128C4.2101 20.0128 5.44073 21.2434 5.44073 22.7628C5.44073 24.2821 4.2101 25.5127 2.69076 25.5127V27.3461Z",
    fill: "url(#paint0_linear_4867_12439)",
    stroke: "url(#paint1_linear_4867_12439)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8037 55.7621H3.74555L2.74641 49.7488C2.70974 49.5311 2.69141 49.3088 2.69141 49.0888V47.888C2.6937 46.8155 3.11994 45.7888 3.87388 45.028C4.07325 44.8332 4.29096 44.659 4.52472 44.5055V27.3457H10.0247V44.5055C10.2584 44.659 10.4761 44.8332 10.6755 45.028C11.4295 45.7888 11.8557 46.8155 11.858 47.888V49.0888C11.858 49.3065 11.8396 49.5242 11.803 49.7396L10.8037 55.7621ZM5.30371 53.9287H9.24537L10.0245 49.4555C10.0337 49.334 10.0337 49.2103 10.0245 49.0888V47.888C10.0199 47.3036 9.78618 46.7444 9.37367 46.3297C9.18576 46.1418 8.96576 45.9882 8.72283 45.8805L8.19117 45.6789V29.179H6.35785V45.6789L5.82619 45.9264C5.58328 46.0341 5.36328 46.1876 5.17535 46.3755C4.76286 46.7903 4.52909 47.3495 4.52451 47.9338V49.1346C4.51535 49.2607 4.51535 49.3844 4.52451 49.5105L5.30371 53.9287Z",
    fill: "url(#paint2_linear_4867_12439)",
    stroke: "url(#paint3_linear_4867_12439)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M34.775 55.2034V45.395L31.1084 43.2775L27.4418 45.395V55.2034L26.0668 54.415C23.028 52.6619 21.1191 49.4559 21.0251 45.9495C20.9312 42.4433 22.6682 39.139 25.6084 37.2276V19.2981C23.1632 17.7055 21.527 15.1342 21.1214 12.2447C20.7181 9.35496 21.5866 6.43081 23.5001 4.2286C25.4159 2.02863 28.1911 0.763672 31.1085 0.763672C34.0259 0.763672 36.8009 2.02863 38.7169 4.2286C40.6304 6.43087 41.499 9.35501 41.0956 12.2447C40.69 15.1345 39.0538 17.7057 36.6086 19.2981V37.2276C39.5488 39.1389 41.2859 42.4434 41.1919 45.9495C41.0979 49.4557 39.189 52.6615 36.1503 54.415L34.775 55.2034ZM31.1084 41.1693L36.6083 44.3317V51.821C38.5746 50.0565 39.5783 47.4578 39.3056 44.8292C39.0352 42.2007 37.5204 39.8633 35.2334 38.5385L34.775 38.2726V18.2529L35.2334 17.987C38.4669 16.1194 40.0435 12.3129 39.0765 8.70843C38.1117 5.10141 34.8415 2.59192 31.1084 2.59192C27.3754 2.59192 24.1049 5.10124 23.1404 8.70843C22.1734 12.3132 23.75 16.1197 26.9835 17.987L27.4419 18.2529V38.2726L26.9835 38.5385C24.6965 39.863 23.1817 42.2005 22.9113 44.8292C22.6386 47.4578 23.6423 50.0565 25.6086 51.821V44.3317L31.1084 41.1693Z",
    fill: "url(#paint4_linear_4867_12439)",
    stroke: "url(#paint5_linear_4867_12439)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M31.1074 17.1896L25.6074 14.0271V7.66538L31.1074 4.50293L36.6073 7.66538V14.0271L31.1074 17.1896ZM27.4407 12.9638L31.1074 15.0813L34.774 12.9638V8.72882L31.1074 6.61133L27.4407 8.72882V12.9638Z",
    fill: "url(#paint6_linear_4867_12439)",
    stroke: "url(#paint7_linear_4867_12439)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4867_12439",
    x1: 12.3332,
    y1: 1.29586,
    x2: -2.18551,
    y2: -2.59763,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D3970"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B1529"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4867_12439",
    x1: 12.3332,
    y1: 1.29586,
    x2: -2.18551,
    y2: -2.59763,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D3970"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B1529"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_4867_12439",
    x1: 10.888,
    y1: 27.8789,
    x2: 0.16562,
    y2: 25.8251,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D3970"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B1529"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_4867_12439",
    x1: 10.888,
    y1: 27.8789,
    x2: 0.16562,
    y2: 25.8251,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D3970"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B1529"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_4867_12439",
    x1: 39.0608,
    y1: 1.7851,
    x2: 15.7267,
    y2: -3.3494,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D3970"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B1529"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_4867_12439",
    x1: 39.0608,
    y1: 1.7851,
    x2: 15.7267,
    y2: -3.3494,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D3970"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B1529"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_4867_12439",
    x1: 35.4434,
    y1: 4.74096,
    x2: 24.8992,
    y2: -0.68755,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D3970"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B1529"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_4867_12439",
    x1: 35.4434,
    y1: 4.74096,
    x2: 24.8992,
    y2: -0.68755,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D3970"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B1529"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoadmapToolsIcon);
export default __webpack_public_path__ + "static/media/roadmap_tools_icon.b11aab37ab684866b78990a765381b2d.svg";
export { ForwardRef as ReactComponent };